// libraries
import React from 'react'
import { Masonry } from 'masonic'

// prop types
export interface MasonicProps {
    items: any[]
    columnGutter: number
    maxColumnCount: number
    columnWidth: number
    render: (item: any, index: number) => React.ReactNode
    className?: string
    overscanBy?: number
}

export default function Masonic({
    items,
    columnGutter,
    maxColumnCount,
    columnWidth,
    render,
    className,
    overscanBy
}: MasonicProps) {
    
    // ensure valid items with keys
    const safeItems = Array.isArray(items) ? items.map((item, i) => 
        !item ? { data: { id: `item-${i}`, isEmpty: true }, key: `item-${i}` } :
        ({ ...item, key: item.id || `item-${i}` })
    ) : []
    
    // return null if no items
    if (safeItems.length === 0) return null
    
    return (
        <Masonry
            items={safeItems}
            columnGutter={columnGutter}
            maxColumnCount={maxColumnCount}
            columnWidth={columnWidth}
            overscanBy={overscanBy || 5}
            render={render}
            className={className}
        />
    )
}